import * as React from 'react';

import X16 from './X16';

export const x16 = () => <X16 />;

export default {
    title: 'Icon|Fill|X16',
    component: X16,
    parameters: {
        notes: "`import X16 from 'box-ui-elements/es/icon/fill/X16';`",
    },
};
